export const buildUrlWithQueryParams = (
  baseUrl: string,
  params: Record<string, string | number | boolean | null | undefined>
): string => {
  const queryParams = Object.entries(params)
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== ''
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&');

  return queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
};
